import { defineStore } from 'pinia'
import { type SpecGroup, type SpecItem } from '../../types'

interface SpecState {
  specList: SpecGroup[]
}

export const useSpec = defineStore('spec', {
  state: (): SpecState => {
    return {
      specList: []
    }
  },
  getters: {
    getSelectedList(): SpecGroup[] {
      return this.specList;
    },
    isCompleted(): boolean {
      return this.specList.every(f => f.selectedItem)
    }
  },
  actions: {
    dataFill(values: SpecGroup[]): void {
      this.specList.splice(0)
      this.specList.push(...values)
      this.specList.forEach(f=>{
        if (f.values.length===1){
          f.selectedItem = f.values[0]
        }
      })
    },

    setSelectedValue(name: string, val: SpecItem | undefined): void {
      const item = this.specList.find((f) => f.name === name)

      if (item) {
        item.selectedItem = val
      }
    }
  }
})
